<section class="flex min-h-0 flex-1 flex-col px-3 py-3">
  @if (!ticketAccess().hasCreateAccess) {
    <div class="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border border-[#ece4f3] bg-[#faf7fc] px-4 py-10 text-center">
      <button
        type="button"
        class="rounded-lg border border-[#ece4f3] px-4 py-2 text-sm font-medium text-[#5a2f6b]"
        (click)="backToList()"
      >
        {{ "mobile.eachat.wizard.backToList" | translate }}
      </button>
    </div>
  } @else if (errorMessageKey()) {
    <div class="flex flex-1 flex-col items-center justify-center gap-4 rounded-2xl border border-destructive/20 bg-destructive/5 px-4 py-10 text-center">
      <span class="material-icons text-[40px] text-destructive" aria-hidden="true">error_outline</span>
      <p class="text-sm text-destructive">{{ errorMessage() }}</p>
      <button
        type="button"
        class="rounded-lg bg-[#5a2f6b] px-4 py-2 text-sm font-semibold text-white"
        (click)="clearError()"
      >
        {{ "common.retry" | translate }}
      </button>
    </div>
  } @else if (isSubmitting()) {
    <div class="flex flex-1 flex-col items-center justify-center gap-4 py-16 text-center">
      <span class="material-icons animate-pulse text-[48px] text-[#5a2f6b]" aria-hidden="true">hourglass_top</span>
      <p class="text-sm text-[#7a6b8a]">{{ "mobile.eachat.voice.generating" | translate }}</p>
    </div>
  } @else {
    <mobile-voice-purchase-request-recorder
      infoTitleKey="mobile.eachat.voice.infoTitle"
      infoBodyKey="mobile.eachat.voice.infoBody"
      (recordError)="onRecordError($event)"
      (sent)="onSent($event)"
    />
  }
</section>
